import axios from "axios";

let csrfToken = null;

export async function fetchCsrfToken() {
  if (csrfToken) {
    return csrfToken;
  }
  const response = await axios.get(
    `${process.env.REACT_APP_AUTH_BASE_URL}/getdetails/csrf-token`,
    {
      withCredentials: true,
      headers: {
        "X-Client": "candidate",
      },
    }
  );
  csrfToken = response.data.data.token;
  // ✅ Do NOT store in localStorage — it's vulnerable to XSS
  return csrfToken;
}

// ✅ Call this on logout to invalidate cached token
export function clearCsrfToken() {
  csrfToken = null;
}